import { UpdatePage } from '@components/molecules';
import { TextFieldElement, SwitchElement, useForm } from 'react-hook-form-mui';
import API from '@apps/localization/services/unit';
import CityAPI from '@apps/localization/services/city';
import DivisionAPI from '@apps/localization/services/division';
import { ModelProps } from '@/types';
import { UnitSchema, UnitSchemaType } from '@apps/localization/schemas/unit';
import { JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { zodResolver } from '@hookform/resolvers/zod';
import AsyncAutocompleteElement from '@/components/atoms/asyncautocomplete';

export default function ObjectUpdatePage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const formContext = useForm<UnitSchemaType>({
    resolver: zodResolver(UnitSchema),
    defaultValues: { is_active: true },
  });

  return (
    <UpdatePage
      schema={UnitSchema}
      api={API}
      title={t('Unit')}
      modelProps={modelProps}
      formcontext={formContext}
      canSaveAndContinue
      keepValues={['city', 'division']}
    >
      <Grid size={{ xs: 12, md: 6 }}>
        <TextFieldElement name="name" label={t('Name')} fullWidth required />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextFieldElement
          name="acronym"
          label={t('Acronym')}
          fullWidth
          required
          slotProps={{ input: { inputProps: { maxLength: 7 } } }}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <AsyncAutocompleteElement
          api={CityAPI.select}
          name="city"
          label={t('City')}
          required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <AsyncAutocompleteElement
          api={DivisionAPI.select}
          name="division"
          label={t('Identified Area')}
          multiple
          fetchOnMount
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextFieldElement
          name="sap_code"
          label={t('Sap Code Split by ; for multiple codes')}
          fullWidth
          required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <SwitchElement name="is_active" label={t('Is Active?')} />
      </Grid>
    </UpdatePage>
  );
}
